import { render, staticRenderFns } from "./MyNavBar.vue?vue&type=template&id=f8b65ae6&scoped=true"
import script from "./MyNavBar.vue?vue&type=script&lang=js"
export * from "./MyNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b65ae6",
  null
  
)

export default component.exports